/**
 * Compatibility entry point for the gifting storefront.
 *
 * This theme's invite, unlock and RSVP experience is implemented by
 * gifting-ambassador.js. Keep this asset in the shared gifting bootstrap so
 * deployments from the AMS theme bundle retain the expected file contract.
 */
(function (window) {
  'use strict';

  var params = new URLSearchParams(window.location.search);

  // Exchange links are owned exclusively by gifting-exchange-app.js.
  if ((params.get('exchange') || '').trim() === '1') {
    return;
  }

  // Re-collab and standard invite flows remain owned by the existing theme
  // implementations (gifting-recollab.js and gifting-ambassador.js).
  if (window.SaboGiftingReCollabMode || window.SaboGiftingAmbassadorMode) {
    return;
  }
})(window);
